//@flow strict

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {Button} from 'src/components/lib/new-button';
import {Button as GenesisButton} from '@spaced-out/ui-design-system/lib/components/Button';
import css from '../booking.css';


export const ConfirmButton = ({
  children,
  onConfirmClick,
  selected,
  onFirstClick,
  disabled,
  color,
  showConfirm,
}: {
  children: React.Node,
  onConfirmClick?: () => mixed,
  selected: boolean,
  onFirstClick: () => mixed,
  disabled: boolean,
  color?: ?string,
  showConfirm: boolean,
}): React.Element<'div'> => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <div className={css.buttonRow}>
      {showConfirm ? (
        <>
          <Button
            size="medium"
            style={{flex: '1'}}
            disabled={disabled}
            onClick={onFirstClick}
            color={color}
          >
            {children}
          </Button>
          {selected && (
            <Button
              size="medium"
              type="primary"
              disabled={disabled}
              onClick={onConfirmClick}
              color={color}
            >
              {t('Confirm', 'Confirm')}
            </Button>
          )}
        </>
      ) : (
        <GenesisButton
          classNames={selected ? {wrapper: css.buttonOnSelect} : {}}
          disabled={disabled}
          onClick={() => {
            onFirstClick();
            onConfirmClick && onConfirmClick();
          }}
          type="tertiary"
        >
          {children}
        </GenesisButton>
      )}
    </div>
  );
};
